export const AVATAR_SIZES = Object.freeze({
	SMALL: 30,
	MEDIUM: 45,
	LARGE: 60,
});